import i18n from '@/i18n';

const VSD420_OverAll = {
    lcb: [
        {
            label: i18n.global.t('Cooling water flow'),
            value: "1.9",
            unit: "L/min"
        },
        {
            label: i18n.global.t('Cooling water temperature'),
            value: "30",
            unit: "℃"
        },
        {
            label: i18n.global.t('X-directional vibration'),
            value: "3.5",
            unit: "mm/s"
        },
        {
            label: i18n.global.t('Y-directional vibration'),
            value: "6.2",
            unit: "mm/s"
        },
        {
            label: i18n.global.t('Inlet pressure'),
            value: "2",
            unit: "mbarA"
        },
        {
            label: i18n.global.t('Inlet temperature'),
            value: "10",
            unit: "℃"
        }
    ],
    lcbdj: [
        {
            label: i18n.global.t('Current'),
            value: "5.82",
            unit: "A"
        },
        {
            label: i18n.global.t('Rotation Speed'),
            value: "2375",
            unit: "rpm"
        },
        {
            label: i18n.global.t('Power consumption'),
            value: "2.1",
            unit: "kW"
        },
        {
            label: i18n.global.t('Bearing temperature'),
            value: "75",
            unit: "℃"
        },
        {
            label: i18n.global.t('X-directional vibration'),
            value: "2.8",
            unit: "mm/s"
        },
        {
            label: i18n.global.t('Y-directional vibration'),
            value: "2.8",
            unit: "mm/s"
        }
    ],
    lgb: [
        {
            label: i18n.global.t('Cooling water flow'),
            value: "10",
            unit: "L/min"
        },
        {
            label: i18n.global.t('Cooling water temperature'),
            value: "30",
            unit: "℃"
        },
        {
            label: i18n.global.t('X-directional vibration'),
            value: "2.8",
            unit: "mm/s"
        },
        {
            label: i18n.global.t('Y-directional vibration'),
            value: "2.8",
            unit: "mm/s"
        },
        {
            label: i18n.global.t('Inlet pressure'),
            value: "9",
            unit: "mbarA"
        },
        {
            label: i18n.global.t('Inlet temperature'),
            value: "70",
            unit: "℃"
        }
    ],
    lgbdj: [
        {
            label: i18n.global.t('Current'),
            value: "22",
            unit: "A"
        },
        {
            label: i18n.global.t('Rotation Speed'),
            value: "2950",
            unit: "rpm"
        },
        {
            label: i18n.global.t('Power consumption'),
            value: "7.7",
            unit: "kW"
        },
        {
            label: i18n.global.t('Bearing temperature'),
            value: "75",
            unit: "℃"
        },
        {
            label: i18n.global.t('X-directional vibration'),
            value: "2.8",
            unit: "mm/s"
        },
        {
            label: i18n.global.t('Y-directional vibration'),
            value: "2.8",
            unit: "mm/s"
        }
    ],
};

const VSD420_High = {
    lcbdj_fqd: [
        {
            label: "加速度峰值",
            value: "20.14",
            status: 'normal'
        },
        {
            label: "速度有效值",
            value: "1.067",
            status: 'normal'
        },
        {
            label: "包络峰值",
            value: "30.25",
            status: 'normal'
        },
        {
            label: "轴承状态",
            value: "0.5",
            status: 'normal'
        },
        {
            label: "轴承温度",
            value: "50",
            status: 'normal'
        },
    ],
    lcbdj_qd: [
        {
            label: "加速度峰值",
            value: "79.64",
            status: 'warning'
        },
        {
            label: "速度有效值",
            value: "1.067",
            status: 'warning'
        },
        {
            label: "包络峰值",
            value: "30.25",
            status: 'normal'
        },
        {
            label: "轴承状态",
            value: "0.5",
            status: 'warning'
        },
        {
            label: "轴承温度",
            value: "50",
            status: 'warning'
        },
    ],
    lcb_qd: [
        {
            label: "加速度峰值",
            value: "80.53",
            status: 'warning'
        },
        {
            label: "速度有效值",
            value: "5.12",
            status: 'warning'
        },
        {
            label: "包络峰值",
            value: "90.23",
            status: 'normal'
        },
        {
            label: "轴承状态",
            value: "0.5",
            status: 'warning'
        },
        {
            label: "轴承温度",
            value: "60",
            status: 'warning'
        },
    ],
    lcb_fqd: [
        {
            label: "加速度峰值",
            value: "120.53",
            status: 'error'
        },
        {
            label: "速度有效值",
            value: "7.21",
            status: 'error'
        },
        {
            label: "包络峰值",
            value: "130.68",
            status: 'normal'
        },
        {
            label: "轴承状态",
            value: "0.5",
            status: 'error'
        },
        {
            label: "轴承温度",
            value: "45",
            status: 'error'
        },
    ],
    lgbdj_fqd: [
        {
            label: "加速度峰值",
            value: "79.64",
            status: 'normal'
        },
        {
            label: "速度有效值",
            value: "1.067",
            status: 'normal'
        },
        {
            label: "包络峰值",
            value: "30.25",
            status: 'normal'
        },
        {
            label: "轴承状态",
            value: "0.5",
            status: 'normal'
        },
        {
            label: "轴承温度",
            value: "50",
            status: 'normal'
        },
    ],
    lgbdj_qd: [
        {
            label: "加速度峰值",
            value: "20.14 ",
            status: 'normal'
        },
        {
            label: "速度有效值",
            value: "1.067",
            status: 'normal'
        },
        {
            label: "包络峰值",
            value: "30.25",
            status: 'normal'
        },
        {
            label: "轴承状态",
            value: "0.5",
            status: 'normal'
        },
        {
            label: "轴承温度",
            value: "50",
            status: 'normal'
        },
    ],
    lgb_qd: [
        {
            label: "加速度峰值",
            value: "20.14 ",
            status: 'normal'
        },
        {
            label: "速度有效值",
            value: "1.067",
            status: 'normal'
        },
        {
            label: "包络峰值",
            value: "30.25",
            status: 'normal'
        },
        {
            label: "轴承状态",
            value: "0.5",
            status: 'normal'
        },
        {
            label: "轴承温度",
            value: "50",
            status: 'normal'
        },
    ],
    lgb_fqd: [
        {
            label: "加速度峰值",
            value: "20.14 ",
            status: 'normal'
        },
        {
            label: "速度有效值",
            value: "1.067",
            status: 'normal'
        },
        {
            label: "包络峰值",
            value: "30.25",
            status: 'normal'
        },
        {
            label: "轴承状态",
            value: "0.5",
            status: 'normal'
        },
        {
            label: "轴承温度",
            value: "50",
            status: 'normal'
        },
    ],

};

const IVD121Data = {
    lxb: [
        {
            label: "离心泵运行/停止",
            value: "运行",
            status: 'normal'
        },
        {
            label: "离心泵就绪/故障",
            value: "故障",
            status: 'error'
        },
    ],
    lq: [
        {
            label: '工作液温度',
            value: "20",
            unit: "℃",
            status: 'normal'
        },
        {
            label: '风扇运行状态',
            value: "运行",
            unit: "",
            status: 'normal'
        },
    ],
    zkb: [
        {
            label: "1#液环真空泵运行/停止",
            value: "运行",
            status: 'normal'
        },
        {
            label: "1#液环真空泵就绪/故障",
            value: "故障",
            status: 'error'
        },
        {
            label: "1#真空泵入口阀",
            value: "开",
            status: 'normal'
        },
        {
            label: "2#液环真空泵运行/停止",
            value: "停止",
            status: 'normal'
        },
        {
            label: "2#液环真空泵就绪/故障",
            value: "就绪",
            status: 'normal'
        },
        {
            label: "2#真空泵入口阀",
            value: "关",
            status: 'normal'
        },
    ]
}

const IV706EData = {
    hrq: [
        {
            label: "工作液入口温度",
            value: "25",
            unit: "℃"
        },
        {
            label: "工作液出口温度",
            value: "15",
            unit: "℃"
        },
        {
            label: "冷却水入口温度",
            value: "10",
            unit: "℃"
        },
        {
            label: "冷却水出口温度",
            value: "13",
            unit: "℃"
        },

    ],
    zkb: [
        {
            label: "入口阀前压力",
            value: "-96",
            unit: "kPaA"
        },
        {
            label: "入口阀后压力",
            value: "-98",
            unit: "kPaA"
        },
        {
            label: "驱动端轴承温度",
            value: "41",
            unit: "℃"
        },
        {
            label: "驱动端轴承振动",
            value: "1.5",
            unit: "mm/s"
        },
        {
            label: "非驱动端轴承温度",
            value: "40.2",
            unit: "℃"
        },
        {
            label: "非驱动端轴承振动",
            value: "1.2",
            unit: "mm/s"
        },
    ],
    zkbdj: [
        {
            label: "运行电流",
            value: "35",
            unit: "A"
        },
        {
            label: "实际转速",
            value: "680",
            unit: "rpm"
        },
        {
            label: "绕组温度U",
            value: "61",
            unit: "℃"
        },
        {
            label: "绕组温度V",
            value: "62",
            unit: "℃"
        },
        {
            label: "绕组温度W",
            value: "60",
            unit: "℃"
        },
        {
            label: "驱动端轴承温度",
            value: "53",
            unit: "℃"
        },
        {
            label: "非驱动端轴承温度",
            value: "54.1",
            unit: "℃"
        },
    ]
}

export {
    VSD420_OverAll,
    VSD420_High,
    IVD121Data,
    IV706EData
}


/*
全景：

罗茨泵电机
转数没小数点
功耗范围2.1正负0.1

罗茨泵
入口压力2-2.1

螺杆泵
电流22，
功率7.7-7.8
---------------------------------
高频振动：
包络：包络
*/